import { LoginTheme } from ".";

// Dark theme: brand colors (navy / green / orange / gold) stay constant —
// they are part of the visual identity. Neutral tokens (ink, muted, soft,
// line, bg) flip to a dark palette.
const theme: LoginTheme = {
  title: "dark",
  colors: {
    primary: "rgb(59,61,80)",
    secondary: "rgb(0,86,154)",
    tertiary: "rgb(0, 41, 81)",
    background: "rgb(26, 30, 48)",
    scrollBar: "#e0e0e0",
    text: "white",
    navBarIcons: "white",
    gray: "#545454",
    error: "#e74c3c",
    success: "#46c17d",
    warning: "#ffad00"
  },
  brand: {
    navy: "#003563",
    navyMed: "#2968A8",
    navyDeep: "#001A33",
    navyHover: "#00285a",
    green: "#99CC33",
    orange: "#CC6600",
    gold: "#FFB733",
    ink: "#f0f2f5",
    muted: "#a5b0c0",
    soft: "#8a9ab0",
    line: "#2c3e50",
    bg: "#1a2636"
  }
};

export default theme;
